import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";

import ADataGrid from "../../../../../views/pages/manage/common/data-grid/ADataGrid";
import { GridRowModes } from "@mui/x-data-grid";


import { fetchAllPromisedData, isObjEmpty } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import { failureToast, successToast } from "../../../../../services/http";
import { saveOrDeleteMsg } from "../../../../../views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";

import { generateRandomId } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { AGridColDef } from "../../../../../views/pages/manage/common/data-grid/ADataGridColDef";
import { editCellContainerStyle } from "../../../../../views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AAutoComplete from "../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete";
import { gridStyles , gridComponents} from "../../../../../views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { ActionsCellComponent } from "../../../../../views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common";
// import { machineTypes, newRow, vendorTypes } from "./common";
import { newRow, transferTypes } from "./utils";
import ALoader from "../../../../../views/pages/manage/common/a-loader";
import NoRowOverlay from "../../../../../views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { FaCheckSquare } from "react-icons/fa";
// import { endpoint } from "../../../../common/constant";
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseSquareBlack.svg";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import MultiSelectCellComponentWithSearch from "../../../../../views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";

const ApprovalSettingTable = (
  {
    rows,
    loading,
    currentPage,
    totalRecords,
    pageChangeHandler,
    allActiveRoles,
    setForm
  },
  ref
) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowData, setRowData] = useState(rows);
  const [rowForm, setRowForm] = useState({});


  const rowFormHandler = (value, key) =>
    setRowForm((prev) => ({
      ...prev,
      [key]: value
    }));

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  const startEditing = (id, form) => {
    // debugger
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "transferType" },
    }));
    setRowForm(form);
  };

  console.log('rowForm', rowForm);

  const stopEditing = () => {
    const currForm = { ...rowForm };
    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    if (params?.row?.isNew) {
      setRowData(rows);
      setRowForm({});
    } else {
      stopEditing(params?.id);
    }
  };

  const handleSaveClick = () => {

    let tempRows = [...rows];

    if(rowForm?.isNew){
      delete rowForm?.isNew;
      tempRows = [...tempRows , rowForm]
    }else{
       tempRows = [
        ...tempRows?.filter(row => row?.id !== rowForm?.id),
        rowForm
      ]
    }
      setForm(prev => ({
      ...prev,
      approvalSettingDTO : tempRows
    }))
    

    stopEditing();
  }

  const handleDeleteClick = (params) => {
    setForm(prev => {
      const deleteId = params?.row?.id;
      let tempRows = [...prev.approvalSettingDTO];
      tempRows = tempRows.filter(row => row?.id !== deleteId);

      return {
        ...prev,
        approvalSettingDTO : tempRows
      }

    })
  }


  const addNewRow = async () => {
    if (!isObjEmpty(rowForm)) {
      failureToast(saveOrDeleteMsg);
    } else {
      let randomId = generateRandomId();
      let emptyRow = {
        ...newRow,
        isNew: true,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
    }
  };

  const isTableInEditMode = Object.keys(rowForm)?.length !== 0;


  useImperativeHandle(ref, () => ({
    addNewRow: addNewRow,
    startEditing: startEditing,
    stopEditing: stopEditing,
    isTableInEditMode : isTableInEditMode
  }));

const getTransferTypesDropdown = (row) => {
  const filteredTypes = transferTypes?.filter(
    type => !rowData?.some(existing => existing?.transferType === type)
  ) || [];

  if (!row.isNew) {
    const currentType = rowData?.find(el => el?.id === row?.id)?.transferType;
    if (currentType) filteredTypes.push(currentType);
  }

  return filteredTypes;
};


  const columns = [

    new AGridColDef("transferType", "Transfer Type", false)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value?.label)
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.transferType}
            handleChange={(value) => {
              rowFormHandler(value, "transferType");
            }}
            items={getTransferTypesDropdown(params?.row)}
            isMulti={false}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),

    new AGridColDef("l1Roles", "L1 Roles*",false)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) => 
        <MultiSelectCellComponentWithSearch
        data={params?.value}
        title={'L1 Roles'}
        />
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.l1Roles}
            // currentValue={rowForm.businessArea ?? rowForm?.businessArea ?? {label : '', value : ''}}
            handleChange={(value) => {
              rowFormHandler(value, "l1Roles");
            }}
            items={allActiveRoles}
            isMulti={true}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isShowCount
          />
        </div>
      )),

    new AGridColDef("l2Roles", "L2 Roles",false)
      .setFlex(1)
      .editable(true)
      .renderCellComponent((params) => 
        <MultiSelectCellComponentWithSearch
        data={params?.value}
        title={'L2 Roles'}
        />
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.l2Roles}
            // currentValue={rowForm?.businessArea ?? {label : '', value : ''}}
            handleChange={(value) => {
              rowFormHandler(value, "l2Roles");
            }}
            items={allActiveRoles}
            isMulti={true}
            placeholder={"Select"}
            autoFocus={params?.hasFocus}
            isShowCount
          />
        </div>
      )),
    
    new AGridColDef("actions", "Action", false)
      // .setMinWidth(110)
      .setFlex(1)
      .editable(true)
      // .pinColumnLast(true)
      .renderCellComponent(
        (params) =>
          
            <ActionsCellComponent
              mode={"view"}
              handleEditClick={handleEditClick}
              params={params}
              deleteIcon
              handleDeleteClick={handleDeleteClick}
            />
          )
      .renderEditCellComponent((params) => (
        <ActionsCellComponent
          mode={"edit"}
          isSaveDisabled={(!rowForm?.transferType || !rowForm?.l1Roles?.length)}
          handleSaveClick={handleSaveClick}
          // handleCancelClick={handleCancelClick}
          params={params}
          cancelIcon={
             <AButton
             variant="danger_filled"
             size="xs"
             onClick={() => handleCancelClick(params)}
             >
              Discard
             </AButton>
          }
        />
      )),
  ];

  return (
    <>
      {loading && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        hidePagination
        nextButtonHandler={pageChangeHandler}
        currentPage={currentPage}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loading ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        autoHeight
        // pinLastColumn
      />
    </>
  );
};

export default forwardRef(ApprovalSettingTable);
